import { BTResource } from 'src/models/Sidekick/SidekickModuleSpec';
import SidekickThread, { NextData } from 'src/models/Sidekick/SidekickThreads';
import { flattenSteps, NestedModuleOrModifier, NodesTypes } from './utils';

export const checkForDeletedBTRResources = async (currentThread: SidekickThread, btResources: BTResource[]) => {
  const errors: { attr: string; code: string; detail: string }[] = [];

  const modsWithExternalActions: NestedModuleOrModifier[] = flattenSteps(currentThread.nextData)
    .filter(mod => mod.nodeType === NodesTypes.MODULE)
    .filter(mod => !!(mod.mod as NextData).btResource);

  const deletedBTResourceActions = modsWithExternalActions.filter(
    mod => !btResources.some(btResource => btResource.id === (mod.mod as NextData).btResource?.id)
  );

  deletedBTResourceActions?.forEach(mod => {
    errors.push({
      attr: mod.attr!,
      code: 'notExists',
      detail: `Remote Glados action ${
        (mod.mod as NextData).btResource?.metadata.name
      } has been deleted. Delete the action from thread.`,
    });
  });

  return errors;
};
